export default __webpack_public_path__ + "static/media/macbook-icon.3896a1ea.svg";